;(function (angular, moment, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('pagination', paginationDirective)

  PaginationController.$inject = ['PreferencesService']

  function PaginationController (PreferencesService) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        changePerPage: changePerPage
      })

      init()
    }

    function init () {
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs
      })
    }

    function changePerPage () {
      if (self.pagination.currentPage >= self.pagination.pageNumber()) {
        self.pagination.currentPage = self.pagination.lastPage()
      }
      self.getList()
    }

    /*    function changePerPage () {
      if (self.prefs.settings && self.type) {
        self.prefs.settings[self.type + 'List'].pagination = self.pagination.perPage
        self.prefs.save().then(function () {
          self.pagination.perPage = self.prefs.settings[self.type + 'List'].pagination
          if (self.pagination.currentPage >= self.pagination.pageNumber()) {
            self.pagination.currentPage = self.pagination.lastPage()
          }
          self.getList()
        })
      }
    } */
  }

  paginationDirective.$inject = []

  function paginationDirective () {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/pagination/pagination.html',
      controller: PaginationController,
      controllerAs: 'ctrl',
      bindToController: {
        pagination: '=',
        type: '@?',
        getList: '&'
      }
    }
  }
})(window.angular, window.moment, window._)
